<template>
    <GoogleMap
        class="relative js-map"
        :center="center"
        :zoom="initialZoom"
        :minZoom="17"
        :options="mapOptions"
        :style="{ height: height + 'px' }"
        v-on:bounds_changed="getDrainsOnMove"
        v-on:zoom_changed="zoomChangedEmitter"
        ref="mapRef"
    >
        <GoogleMapMarker
            v-for="(drain, index) in drains"
            :key="index"
            :drain="drain"
            :position="getPosition(drain)"
            :my-drain-ids="myDrainIds"
            :adopted-drain-ids="adoptedDrainIds"
        ></GoogleMapMarker>

        <!-- Use for debugging to make certain of hovering suggest pin accuracy
        <gmap-marker
            :icon="{
                icon: '/images/map-pin-suggest.png',
                scaledSize: { width: 23, height: 60 },
            }"
            :key="null"
            :position="this.center"
        >
        </gmap-marker> -->

        <div slot="visible">
            <div
                class="absolute z-40 flex items-center px-5 py-2 bg-white text-md"
                style="top: 10px; right: 60px; box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;"
            >
                <div v-if="this.user != null" class="flex items-center">
                    <img src="/images/map-pin-purple.png" class="w-4 mr-1" />
                    <p class="pt-1 mr-2">My Drain</p>
                </div>

                <img src="/images/map-pin-blue.png" class="w-4 mr-1" />
                <p class="pt-1 mr-2">Adopted Drain</p>

                <img src="/images/map-pin-yellow.png" class="w-4 mr-1" />
                <p class="pt-1">Un-Adopted Drain</p>
            </div>

            <div
                class="absolute"
                style="bottom: calc(50% - 4px);; left: calc(50% - 12px);"
            >
                <img
                    src="/images/map-pin-suggest.png"
                    style="height: 60px; width: auto;"
                />
            </div>

            <input
                type="hidden"
                name="suggestion_lat"
                :value="reportedCenter.lat"
            />
            <input
                type="hidden"
                name="suggestion_lng"
                :value="reportedCenter.lng"
            />
            <button
                type="submit"
                on-click="suggestDrain"
                :disabled="!canSuggestDrain"
                :class="'absolute font-bold text-center text-lg z-40 text-white leading-normal py-4 px-6 rounded-xl ' +
                        (canSuggestDrain
                            ? 'bg-orange hover:bg-orange-dark'
                            : 'bg-grey-dark cursor-not-allowed')
                "
                style="bottom: 10px; left: 50%; margin-left: -125px; box-shadow: rgba(0, 0, 0, 0.6) 0px 2px 6px -2px; width: 250px;"
                v-html="
                    canSuggestDrain
                        ? 'Add &amp; adopt this drain'
                        : loading
                        ? 'Loading...'
                        : 'Please check the adoption checkbox'
                "
            ></button>
        </div>
    </GoogleMap>
</template>

<script>
import { GoogleMap } from "vue3-google-map";
import GoogleMapMarker from './GoogleMapMarker';

export default {
    components: { GoogleMapMarker, GoogleMap },

    props: {
        adoptedDrainIds: { default: null },
        height: { default: 430 },
        initialZoom: { default: 17 },
        initialCenter: {},
        myDrainIds: { default: null },
        confirmWillAdoptSuggestion: {},
        user: { default: null },
    },

    data() {
        return {
            drains: [],
            loading: true,
            center: this.initialCenter,
            reportedCenter: this.initialCenter,
            displayInfoPopup: false,
            mapOptions: {
                fullscreenControl: false,
                minZoom: 17,
                maxZoom: 20,
                styles: [
                    {
                        featureType: 'poi.business',
                        stylers: [{ visibility: 'off' }],
                    },
                ],
            },
        };
    },

    mounted() {
        if (this.initialSelectedDrain) {
            this.center = this.getPosition(this.initialSelectedDrain);
        }
    },

    methods: {
        getPosition(drain) {
            return { lat: drain.latitude, lng: drain.longitude };
        },
        setPlace(place) {
            this.center = place.geometry.location;
        },
        generateQueryString(object) {
            var str = [];

            for (var item in object) {
                if (object.hasOwnProperty(item)) {
                    str.push(
                        encodeURIComponent(item) +
                            '=' +
                            encodeURIComponent(object[item])
                    );
                }
            }

            return str.join('&');
        },
        getDrainsOnMove() {
            this.loading = true;
            this.getDrainsOnMoveDebounced(this.$refs.mapRef.map.getBounds());
        },
        getDrainsOnMoveDebounced: _.debounce(function(bounds) {
            if (!bounds) return;

            let data = {
                top: bounds.getNorthEast().lat(),
                bottom: bounds.getSouthWest().lat(),
                left: bounds.getSouthWest().lng(),
                right: bounds.getNorthEast().lng(),
            };

            this.$emit('update:center', {
                lat: bounds.getCenter().lat(),
                lng: bounds.getCenter().lng(),
            });

            this.reportedCenter = {
                lat: bounds.getCenter().lat(),
                lng: bounds.getCenter().lng(),
            };

            window.axios
                .request({
                    url:
                        '/internal-api/drains/?' +
                        this.generateQueryString(data),
                    method: 'get',
                })
                .then(
                    response => {
                        this.drains = response.data.data;
                        this.loading = false;
                    },
                    response => {
                        console.log(response);
                    }
                );
        }, 500),
        zoomChangedEmitter(zoomLevel) {
            this.$emit('update:zoom', zoomLevel);
        },
    },

    computed: {
        canSuggestDrain: function() {
            return !this.loading && this.confirmWillAdoptSuggestion;
        },
    },

    watch: {
        initialCenter(coordinates) {
            this.center = coordinates;
        },
    },
};
</script>
